// src/sim/map/grid.ts — pure grid queries (MAP-12).
//
// Invariants:
//   - No side effects; grid is treated as read-only input.
//   - Out-of-bounds coords return "blocked" (false), never throw.
//   - bgrins convention: 0 = walkable, 1 = blocked.
//
// Source: Phase 1 PATTERNS.md §src/sim/map/grid.ts.

import type { WalkabilityGrid, Vec2 } from '../../shared/types/map';

/** True iff (x, y) is in bounds AND grid[y][x] === 0 (walkable). */
export function isWalkable(grid: WalkabilityGrid, x: number, y: number): boolean {
  if (y < 0 || y >= grid.length) return false;
  const row = grid[y];
  if (!row) return false;
  if (x < 0 || x >= row.length) return false;
  return row[x] === 0;
}

/** Raw grid value at (x, y); returns 1 (blocked) for out-of-bounds. */
export function tileAt(grid: WalkabilityGrid, x: number, y: number): number {
  if (y < 0 || y >= grid.length) return 1;
  const row = grid[y];
  if (!row) return 1;
  if (x < 0 || x >= row.length) return 1;
  return row[x] ?? 1;
}

/** Pixel position → tile (floor division by tile size). */
export function worldToTile(pos: Vec2, tileWidth: number, tileHeight: number): Vec2 {
  return {
    x: Math.floor(pos.x / tileWidth),
    y: Math.floor(pos.y / tileHeight),
  };
}
